import { securedAxiosAPI } from 'utils/axios';
import { store } from '../../store';
// APIS

// Secured Routes

const securedRoute = {
    base: 'labTest',
    byPaginationAndStatus: '/labTest/getByPagination',
    add: 'labTest/add',
    expiredList: 'labTest/disposal',
    archiveList: 'labTest/archive',
    updateArchiveStatus: 'labTest/update-archive-status',
    dynamicFilter: 'labTest/dynamic-filter',
    dynamicFilterDisposal: 'labTest/disposal-dynamic-filter',
    labManagementDashBoard: 'labTest/labDashboard',
    // Dashboards
    dasboard: 'labTest/dasboard',
    customerDashboard: 'customerPortal',
    labDataByTestReqID: 'customerPortal/findLabTestDataByTestRequestId'
};

// Axios call

// export const labTestsByStatus = async (data) => {
//     const res = await securedAxiosAPI.post(securedRoute?.base, data);
//     return res.data;
// };

export const labTestsByStatus = async (payload) => {
    const { labStatus, columnFilterName } = payload;
    const { getState } = store;
    const { page, rowsPerPage } = getState().lab;
    const { [columnFilterName]: columnFilter } = getState().testRequests;

    const { customerId } = getState().user.loggedInUser;
    const filters = Object.keys(columnFilter);
    const data = {
        products: [],
        sampleType: [],
        sampleId: [],
        testType: [],
        batch: [],
        customers: [],
        branches: [],
        status: [],
        tatDate: [],
        reqDate: [],
        customersRef: []
    };
    filters.forEach((filterName) => {
        if (!data[filterName]) data[filterName] = [];
        columnFilter[filterName]?.appliedList?.forEach((item) => {
            if (filterName === 'tatDate' || filterName === 'reqDate') {
                data[filterName].push(item);
            } else {
                data[filterName].push(item.id);
            }
        });
    });

    const res = await securedAxiosAPI.post(`${securedRoute?.base}/columnDynamicFilter`, {
        ...data,
        page,
        rowsPerPage,
        customerId,
        labStatus
    });

    return res.data;
};
export const labTestsDetailByTestRequestId = async (id) => {
    const { getState } = store;
    const { loggedInPortal } = getState().user;
    const { customerId } = getState().user.loggedInUser;
    let res;
    if (loggedInPortal === 'LAB') {
        res = await securedAxiosAPI.get(`${securedRoute?.base}/testRequestId/${id}`);
    } else if (loggedInPortal === 'CUSTOMER') {
        res = await securedAxiosAPI.post(securedRoute?.labDataByTestReqID, { test_request_id: id, customer_id: customerId });
    }
    return res.data[0];
};

export const labTestDetailsById = async (id) => {
    const res = await securedAxiosAPI.get(`${securedRoute?.base}/${id}`);
    return res.data[0];
};
export const addUpdateLabTest = async (data) => {
    const res = await securedAxiosAPI.post(`${securedRoute?.add}`, data);
    return res.data;
};
// Update status
export const labTestStatusUpdate = async (data) => {
    const res = await securedAxiosAPI.post(`${securedRoute?.base}/update-status`, data);
    return res.data[0];
};
// Result Entered or Finalized List
export const labTestResultEnteredResultFinalized = async () => {
    const { getState } = store;
    const { page, rowsPerPage } = getState().lab;
    const res = await securedAxiosAPI.post(`${securedRoute?.base}/results-enterd-and-finalized`, { page, rowsPerPage });
    return res.data;
};
// Report  Sample Log
export const labTestReportSampleLog = async (data) => {
    const res = await securedAxiosAPI.post(`${securedRoute?.base}/report`, data);
    return res.data;
};
// Dashboard
export const dashboards = async () => {
    const { getState } = store;

    const { loggedInPortal } = getState().user;
    const { customerId } = getState().user.loggedInUser;
    let res;
    if (loggedInPortal === 'LAB') {
        res = await securedAxiosAPI.get(securedRoute?.dasboard);
    } else if (loggedInPortal === 'CUSTOMER') {
        //
        res = await securedAxiosAPI.get(`${securedRoute?.customerDashboard}/${customerId}`);
    }

    return res.data;
};
// expired List
export const expiredlabTests = async (data) => {
    const { getState } = store;
    const { page, rowsPerPage } = getState().lab;
    const res = await securedAxiosAPI.post(securedRoute?.expiredList, { ...data, page, rowsPerPage });
    return res.data;
};
// archived List
export const archivedlabTests = async () => {
    const { getState } = store;
    const { page, rowsPerPage } = getState().lab;
    const res = await securedAxiosAPI.post(securedRoute?.archiveList, { page, rowsPerPage });
    return res.data;
};
// update archive status
export const updateArchiveStatus = async (data) => {
    const res = await securedAxiosAPI.post(securedRoute?.updateArchiveStatus, data);
    return res.data;
};

// Lab Filter
export const labTestFilter = async (data) => {
    const res = await securedAxiosAPI.post(securedRoute?.dynamicFilter, data);
    return res.data;
};
// Disposal Filter
export const labTestDisposalFilter = async (data) => {
    const res = await securedAxiosAPI.post(securedRoute?.dynamicFilterDisposal, data);
    return res.data;
};
// LAB DASHBOARD
export const labManagementDashBoard = async (data) => {
    const res = await securedAxiosAPI.post(securedRoute?.labManagementDashBoard, data);
    return res.data;
};

export const getSystemAuditTrailList = async ({ payload }) => {
    const { page, limit, ...filters } = payload;
    const params = new URLSearchParams({
        page,
        rowsPerPage: limit
    });

    Object.entries(filters).forEach(([key, value]) => {
        if (Array.isArray(value)) {
            value.forEach((item) => {
                if (item !== '' && item !== null && item !== undefined) {
                    params.append(key, item);
                }
            });
        } else if (value !== '' && value !== null && value !== undefined) {
            params.append(key, value);
        }
    });

    const res = await securedAxiosAPI.get(`audit-log?${params.toString()}`);
    return res.data;
};

export const auditTrailFilters = async () => {
    const res = await securedAxiosAPI.get(`audit-log/filters`);
    return res.data;
};

export const auditTrailDownload = async (payload) => {
    const response = await securedAxiosAPI.get(`audit-log/excel-file`, {
        params: payload,
        responseType: 'blob'
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));

    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'audit-report.xlsx');

    document.body.appendChild(link);
    link.click();
    link.remove();
};
